import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { AuthService } from '#services/auth/auth.service';

@Component({
  selector: 'app-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  styleUrls: ['./impersonation-banner.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class ImpersonationBannerComponent {
  get activePermission() {
    return this.authService.activePermission;
  }

  constructor(private authService: AuthService) {}
}
